// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { dealerInformationStyles } from "@insite/content-library/Widgets/DealerDetails/DealerInformation";
import { GridItemProps } from "@insite/mobius/GridItem";
import { createLinkIconStyles } from "@rc/App/SharedStyles/sharedStyles";
import ArrowRedLeftInactive2 from "@rc/XDL/Icons/ArrowRedLeftInactive2";

import { css } from "styled-components";

const sharedStyle = {
    width: 6,
    css: css`
        &&&& {
            margin-bottom: 20px;
        }
    `,
} as GridItemProps;

dealerInformationStyles.googleMapsDirectionLinkGridItem = sharedStyle;
dealerInformationStyles.visitWebsiteLinkGridItem = sharedStyle;

dealerInformationStyles.selectedDealerDisplayBackToResultsLink = {
    ...createLinkIconStyles(ArrowRedLeftInactive2),
};

dealerInformationStyles.nameText = {
    ...dealerInformationStyles.nameText,
    size: 30,
};

dealerInformationStyles.nameGridItem = {
    ...dealerInformationStyles.nameGridItem,
    css: css`
        padding-left: 5px;
    `,
};

dealerInformationStyles.addressInfoGridItem = {
    ...dealerInformationStyles.addressInfoGridItem,
    css: css`
        &&& {
            svg {
                position: relative;
                top: 8px;
            }
        }
    `,
};
